import React from "react";
import { detectURLs, formatJsonToString } from "./orderUtils";

export default function PaymentInfo({ singleOrder }) {
  const paymentMethod = singleOrder.order_payment_method;

  return (
    <div className="d-flex mb-3">
      <div className="mr-4">
        <div className="customer-details">
          <h6>Payment Status:</h6>
          <h5 className="text-capitalize">
            {singleOrder.order_paid === true ? (
              <span className="badge badge-pill badge-outline-success p-2">
                Paid
              </span>
            ) : (
              <span className="badge badge-pill badge-outline-danger p-2">
                Not Paid
              </span>
            )}
          </h5>
        </div>
      </div>
      <div className="mr-4">
        <div className="customer-details">
          <h6>Payment Method:</h6>
          <h5 className="text-capitalize">{paymentMethod?.name}</h5>
        </div>
      </div>
      <div>
        <div className="customer-details">
          <h6>Payment Details:</h6>
          {paymentMethod?.details ? (
            <h5>
              {formatJsonToString(
                paymentMethod.details.split(",").map(function (item, idx) {
                  return detectURLs(item) ? (
                    <a
                      href={item.trim()}
                      key={idx}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {item}
                      <br />
                    </a>
                  ) : (
                    <span key={idx}>
                      {item}
                      <br />
                    </span>
                  );
                })
              )}
            </h5>
          ) : (
            <h5>No Details</h5>
          )}
        </div>
      </div>
    </div>
  );
}
